import { render, staticRenderFns } from "./McBasicTable.vue?vue&type=template&id=1eaa7b54&scoped=true&"
import script from "./McBasicTable.vue?vue&type=script&lang=js&"
export * from "./McBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./McBasicTable.vue?vue&type=style&index=0&id=1eaa7b54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaa7b54",
  null
  
)

export default component.exports